import { api } from '@/service/http';
import { dxUiNotify } from '@/utils/dx-helper';

const displayError = (message, result) => {
    let msg = message;
    if (result.msg) {
        msg += `, ${result.msg}`
    }
    if (result.uuid) {
        msg += ` (${result.uuid})`
    }
    dxUiNotify(msg, 'error', 10000);
}

// region get data
const getTepTreeData = async (args) => {
    const result = await api('tep-grid./tep/tep-tree/data/get', args);
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getTepTreeData', result);
    }
    return [];
}

const getTepTreeSearch = async (search_str) => {
    const result = await api('tep-grid./tep/tep-tree/search/get', {search_str});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getTepTreeSearch', result);
    }
    return [];
}

const getCardVidName = async (kod_vid) => {
    const result = await api('tep-grid./tep/card-vid/name/get', { kod_vid });
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getCardVidName', result);
    }
    return 'Главное';
}

const getCardVidData = async (kod_sx, kod_vid) => {
    const result = await api('tep-grid./tep/card-vid/data/get', { kod_sx, kod_vid });
    if (result.result) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getCardVidData', result);
        displayError('Не удалось зарузить данные элемента ТС. Попробуйте еще раз', result);
    }
    return null;
}

const getNewPath = async (kod_r) => {
    const result = await api('tep-grid./tep/card-vid/new-path/get', { kod_r });
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getNewPath', result);
    }
    return '';
}

const getMenuItemsVid = async (/*kod_vid*/) => {
    // const result = await api('tep-grid./tep/menu-vid/data/get', {kod_vid});
    // if (result.result && result.data) {
    //     return result.data;
    // } else if (!result.result) {
    //     console.error('getMenuItemsVid', result);
    // }
    return [];
}

const getAllMenuItemsVid = async () => {
    const result = await api('tep-grid./tep/menu-vid/data/get', {});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getAllMenuItemsVid', result);
    }
    return [];
}

const getCreateItemsMenuVid = async (/*kod_vid*/) => {
    // const result = await api('tep-grid./tep/menu-create-vid/data/get', {kod_vid});
    // if (result.result && result.data) {
    //     return result.data;
    // } else if (!result.result) {
    //     console.error('getCreateItemsMenuVid', result);
    // }
    return [];
}

const getAllCreateItemsMenuVid = async () => {
    const result = await api('tep-grid./tep/menu-create-vid/data/get', {});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getAllCreateItemsMenuVid', result);
    }
    return [];
}

const getAllTreeItemChildren = async (dep, parentKod, loadedItems) => {
    const result = await api('tep-grid./tep/tep-tree-all-children/data/get', {dep, parentKod, loadedItems});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getAllCreateItemsMenuVid', result);
        displayError('Произошла ошибка загрузки элементов структуры ТС', result);
    }
    return [];
}

const getOrgEmployeeName = async (kodp) => {
    const result = await api('tep-grid./tep/org-employee-name/get', {kodp});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getOrgEmployeeName', result);
    }
    return '';
}

const getAllRatesData = async () => {
    const result = await api('tep-grid./tep/all-rates-data/get', {});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getAllRatesData', result);
    }
    return [];
}

const getTrgLookupYearsList = async () => {
    const result = await api('tep-grid./tep/tgr-years-list/get', {});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getTrgLookupYearsList', result);
    }
    return [];
}

const getTgrLookupKontur = async () => {
    const result = await api('tep-grid./tep/tgr-lookup-kontur/get', {});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getTgrLookupKontur', result);
    }
    return [];
}

const getTgrLookupStation = async () => {
    const result = await api('tep-grid./tep/tgr-lookup-st/get', {});
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getTgrLookupStation', result);
    }
    return [];
}

const getCardVidSxName = async (data) => {
    const result = await api('tep-grid./tep/card-vid/sx-name/get', data);
    if (result.result && result.data) {
        return result.data;
    } else if (!result.result) {
        console.error('$TEP_INFO$ getCardVidSxName', result);
    }
    return '';
}

const getAuprTipTnData = async (kod_sx) => {
    const result = await api('tep-grid./tep/card-vid/aupr-tip-tn-data/get', { kod_sx });
    if (result.result && result.data) {
        return result.data[0];
    } else if (!result.result) {
        console.error('$TEP_INFO$ getAuprTipTnData', result);
    }
    return {};
}

const getSxTempData = async (tip_tn, kod_tgr) => {
    const result =  await api('tep-grid./tep/card-vid/sx-temp-data/get',{tip_tn, kod_tgr});
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getSxTempData', result);
    }
    return {}
}

const getLookupsDataTepNet = async (apiSrc, args) => {
    const result =  await api( apiSrc, args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getLookupsDataTepNet', result);
    }
    return []
}

const getQrUchNewRow = async (args) => {
    const result = await api('tep-grid./tep/widgets/qr-uch-new-row/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getQrUchNewRow', result);
    }
    return []
}

const getHarpName = async(kod_harp) => {
    const result =  await api('tep-grid./tep/card-vid/harp-name/get',{kod_harp});
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getHarpName', result);
    }
    return {}
}

const getHarpRaschet = async(args) => {
    const result =  await api('tep-grid./tep/card-vid/harp-raschet/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getHarpRaschet', result);
    }
    return {}
}

const getNagrRasxDdatval = async(args) => {
    const result =  await api('tep-grid./tep/widgets/nagr-rasx-ddatval/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getNagrRasxDdatval', result);
    }
    return null;
}

const getLookupDdatval = async (args) => {
    const result =  await api('tep-grid./tep/widgets/lookup-ddatval/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getLookupDdatval', result);
    }
    return [];
}

const getNagrRasxPar = async(args) => {
    const result =  await api('tep-grid./tep/widgets/nagr-rasx-par/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getNagrRasxPar', result);
    }
    return {};
}

const getNagrRasxWater = async(args) => {
    const result = await api('tep-grid./tep/widgets/nagr-rasx-water/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getNagrRasxWater', result);
    }
    return {};
}

const getPoteriWaterFields = async(args) => {
    const result = await api('tep-grid./tep/widgets/poteri-water-fields/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getPoteriWaterFields', result);
    }
    return {};
}

const getPoteriParFields = async(args) => {
    const result = await api('tep-grid./tep/widgets/poteri-par-fields/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getPoteriParFields', result);
    }
    return {};
}

const getWidgetPvName = async(args) => {
    const result = await api('tep-grid./tep/widgets/pv-name/get', args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getWidgetPvName', result);
    }
    return null;
}

const getLookupsQkSxpris = async(apiSrc ,args) => {
    const result =  await api( apiSrc, args);
    if (result.result && result.data) {
        return result.data
    } else if (!result.result) {
        console.error('$TEP_INFO$ getLookupsQkSxpris', result);
    }
    return []
}
// end region

// region set data
const setTreeItemKodr = async (kod, kod_r) => {
    const result = await api('tep-grid./tep/tep-tree/move-item/set', {kod, kod_r});
    if (!result.result) {
        console.error('$TEP_INFO$ setTreeItemKodr', result);
        displayError('Произошла ошибка перемещения элемента', result);
    }
    return result.result;
}

const setNewTreeItem = async (itemData, kod_r) => {
    const result = await api('tep-grid./tep/tep-tree/create-item/set', {...itemData, kod_r});
    if (!result.result) {
        console.error('$TEP_INFO$ setNewTreeItem', result);
        displayError('Произошла ошибка создания элемента ТС', result);
    }
    return result;
}

const setTreeItemDeleted = async (kod) => {
    const result = await api('tep-grid./tep/tep-tree/delete-item/set', {kod});
    if (!result.result) {
        console.error('$TEP_INFO$ setTreeItemDeleted', result);
        displayError('Произошла ошибка удаления элемента', result);
    }
    return result.result;
}

const setTreeItemData = async (itemData) => {
    const result = await api('tep-grid./tep/tep-tree/update-item/set', itemData);
    if (!result.result) {
        console.error('$TEP_INFO$ setTreeItemData', result);
        displayError('Произошла ошибка обновления элемента', result);
    }
    return result;
}

const setTgrCopyLastYear = async (year) => {
    const result = await api('tep-grid./tep/tgr-copy-last-year/set', {year});
    if (!result.result) {
        console.error('$TEP_INFO$ setTgrCopyLastYear', result);
        displayError('Произошла ошибка копирования графиков', result);
    }
    return result;
}
// endregion

export default {
    getCardVidName: getCardVidName,
    getCardVidData: getCardVidData,
    getNewPath: getNewPath,
    getTepTreeData: getTepTreeData,
    getTepTreeSearch: getTepTreeSearch,
    getMenuItemsVid: getMenuItemsVid,
    getCreateItemsMenuVid: getCreateItemsMenuVid,
    getAllCreateItemsMenuVid: getAllCreateItemsMenuVid,
    getAllMenuItemsVid: getAllMenuItemsVid,
    getAllTreeItemChildren: getAllTreeItemChildren,
    getOrgEmployeeName: getOrgEmployeeName,
    getAllRatesData: getAllRatesData,
    getTrgLookupYearsList: getTrgLookupYearsList,
    getTgrLookupKontur: getTgrLookupKontur,
    getTgrLookupStation: getTgrLookupStation,
    getCardVidSxName: getCardVidSxName,
    getAuprTipTnData: getAuprTipTnData,
    getSxTempData: getSxTempData,
    getLookupsDataTepNet: getLookupsDataTepNet,
    getQrUchNewRow: getQrUchNewRow,
    getHarpName: getHarpName,
    getHarpRaschet: getHarpRaschet,
    getNagrRasxDdatval: getNagrRasxDdatval,
    getLookupDdatval: getLookupDdatval,
    getNagrRasxPar: getNagrRasxPar,
    getNagrRasxWater: getNagrRasxWater,
    getPoteriWaterFields: getPoteriWaterFields,
    getPoteriParFields: getPoteriParFields,
    getWidgetPvName: getWidgetPvName,
    getLookupsQkSxpris: getLookupsQkSxpris,
    setTreeItemKodr: setTreeItemKodr,
    setTreeItemDeleted: setTreeItemDeleted,
    setNewTreeItem: setNewTreeItem,
    setTreeItemData: setTreeItemData,
    setTgrCopyLastYear: setTgrCopyLastYear
}
